import {
  Button,
  Chip,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  IconButton,
  makeStyles,
  Snackbar,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Theme,
  Tooltip,
  Typography,
} from "@material-ui/core";
import * as React from "react";
import {useEffect, useState, useRef} from "react";
import { useHistory } from 'react-router-dom';
import {createTheme, ThemeProvider, withStyles} from '@material-ui/core/styles';
import {environment} from "src/environments/environment";
import {secondaryTextColor, white} from "src/components/colors";
import {SearchBar} from "src/components/sub-components/SearchBar";
import {EditProductType} from "./EditProductType";
import {ViewProductType} from "./ViewProductType";
import {DeleteProductType, ToggleConfig} from "./DeleteProductType";
import { DeleteBlackIcon, DeleteIconLarge, EditIconLarge, EditIconLargeDark, EditIconTwo, ExpandCollapseIcon, ExpandIcon, RMOTAConfigurationIcon, TrashIcon, ViewIcon, ViewIconNew } from "src/components/Icons";
import { primaryBlue } from "src/components/colors";

import axios from "axios";
import useStyles from "src/app/maintenance/assets/styles";
import { DevicesProductType } from "./DeviceProductType";
import { getDevicesWithProductType } from "../api-helper/apiHelper";
import { AuthService } from "src/app/authentication/auth.service";
import { Alert, Pagination } from "@material-ui/lab";
import { LoadingScreen } from "src/components/sub-components/LoadingScreen";
import Cookies from "js-cookie";
import { addProductTypeToDevices, fetchProductType, fetchProductTypeDevices, fetchUnassignedDevicesByProductType, getAllSensors, removeProductTypeFromDevices } from "src/app/maintenance/test-automation/components/apiHelper";
import { DialogPopup } from "src/app/maintenance/test-automation/components/DialogPopup";
import { MultiSelectDropDown } from "src/app/maintenance/test-automation/components/MultiSelectDropDown";
import { DropDown } from "src/app/setup-senzmatica/step-3/components/DropDown";
import { ToasterComponent } from "src/app/maintenance/test-automation/components/Toaster";
import { hasPackagePermission } from "src/app/authentication/package.permission";
import { Close } from "@material-ui/icons";
import { EditRMOTA } from "./EditRMOTA";
import { isVersionGreater, normalizeVersionStr } from "src/app/utils";
import { getLatestVersion } from "./versionUtils";

export function ConfigurationProduct(props) {
  const style = useStyles();
  const classes = useLocalStyles();
  const history = useHistory();
  const theme = createTheme({
    typography: {
      fontFamily: "'Poppins', sans-serif",
    },
  });
  const [search, setSearch] = useState("");
  const [selectedType, setSelectedType] = useState({
    productName: "",
    otaUpgradable: false,
    remotelyConfigurable: false,
    sensorCodes: [],
    actuatorCodes: [],
    connectivity: "",
    protocol: "",
    persistence: "",
    dataFormat: "",
    versions: [],
    codecName: "",
    transcoder: "",
    id: ""
  });
  
  const [products, setProducts] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [reviewOpen, setReviewOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [filteredProducts, setFilteredProducts] = useState(products);
  const [expandedRow,setExpandedRow] = useState(null);
  const [devicesProductExpanded,setDevicesProductExpanded]=useState([]);
  const [searchDevice,setSearchDevice]=useState("");
  const [filterDevices,setFilterDevices] = useState([])
  const [devicesNotInProductType, setDevicesNotInProductType] = useState([])
  const [isAddDeviceVisible, setIsAddDeviceVisible] = useState(false)
  const [selectedDevices, setSelectedDevices] = useState([])
  const [selectedProductTypeVersion,setSelectedProductTypeVersion] = useState("")
  const [prodctTypeVersions,setProdctTypeVersions] = useState([])
  const [productTypeRMOTAEdit,setProductTypeRMOTAEdit]=useState({    
    productName: "",
    otaUpgradable: false,
    remotelyConfigurable: false,
    dataFormat: "",
    versions: [],
    id: "",
    remoteConfigAckTopic:"",
    remoteConfigTopic:"",
    otaAckTopic:"",
    otaRequestTopic:"",
    })

  //edit product related states 
  const [productTypeConfigView,setproductTypeConfigView]=useState(true);
  const[productTypeDeviceView,setProductTypeDeviceView]=useState(false);
  const [updatedOtaUpgradable, setUpdatedOtaUpgradable] = useState(selectedType.otaUpgradable);
  const [updatedRemotelyConfigurable, setUpdatedRemotelyConfigurable] = useState(selectedType.remotelyConfigurable);
  const [updatedDataFormat, setUpdatedDataFormat] = useState(selectedType.dataFormat);
  const [updatedPersistence, setUpdatedPersistence] = useState(selectedType.persistence);
  const [updatedConnectivity, setUpdatedConnectivity] = useState(selectedType.connectivity);
  const [updatedProtocol, setUpdatedProtocol] = useState(selectedType.protocol);
  const [updatedCodecName, setUpdatedCodecName] = useState(selectedType.codecName);
  const [updatedProductName, setUpdatedProductName] = useState(selectedType.productName);
  const [updatedVersion, setUpdatedVersion] = useState(selectedType.versions);
  const [sensorCodesOfDevice, setSensorCodesOfDevice] = useState(selectedType.sensorCodes);
  const [actuatorCodesOfDevice, setActuatorCodesOfDevice] = useState(selectedType.actuatorCodes);
  const [sensorsOfDevice,setSensorsOfDevice]=useState([]);
  const [actuatorsOfDevice,setActuatorsOfDevice]=useState([]);
  const [parameters, setParameters] = useState([]);
  const [intialParameters,setInitialParameters]=useState([]);
  const [codecToSend, setCodecToSend] = useState("");
  const [selectedCodec, setSelectedCodec] = useState('');
  const [versions, setVersions] = useState<{ [key: number]: { label: string; value: string }[] }>({});
  const [type, setType] = useState("");
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [baseVersionNum,setBaseVersionNum]=useState("N/A");
  const [lastVersion,setLastVersion]=useState("N/A");
  const [versionNumEdit,setVersionNumEdit]=useState();
  const [isCurrentVersionUpdated,setIsCurrentVersionUpdated]=useState(false);
    const [upgradePopup, setUpgradePopup] = useState({
      open: false,
      featureName: ''
    });
  const [isVersionManagement,setIsVersionManagment]=useState(false);



  //Toaster
  const [isToasterOpen, setIsToasterOpen] = useState(false);
  const [toasterMessage, setToasterMessage] = useState("");
  const [reqSuccess, setReqSuccess] = useState(false);


  const [sensors, setSensors] = useState([]);
  const [actuators, setActuators] = useState([]);
  const [step, setStep] = useState("");
  const [codecs, setCodecs] = useState([]);
  const [metaData, setMetaData] = useState(null);

  const [isToggled, setIsToggled] = useState(selectedType.transcoder);
  const [loadingScreen, setLoadingScreen] = useState(false);
  const [devicesProd, setDevicesProd] = useState([]);

  const [configEnable, setconfigEnable] = useState(false);
  const [editRMOTAOpen, setEditRMOTAOpen] = useState(false);
  const [toggleOpen,setToggleOpen]=useState(false);
  const [toggleType,setToggleType]=useState("");


  const isInitialMount = useRef(true);
  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      const uId = AuthService.getUserId();
      getAllProducts();
      getAllSensores();
      fetchMetaData();
    }
  }, []);
  useEffect(() => {
    if(sensorCodesOfDevice){
      const names = sensorCodesOfDevice.map(code => {
        const sensor = sensors.find(s => s.code === code);
        return sensor
      });
      setSensorsOfDevice(names);
    }
    if (actuatorCodesOfDevice && metaData) {
      const actuatorNames = actuatorCodesOfDevice.map(code => {
        const actuator = metaData.actuators.find(s => s.code === code);
        return actuator ? actuator.name : code;
      });
      setActuatorsOfDevice(actuatorNames);
    }
  }, [sensorCodesOfDevice,sensors,metaData]);
  useEffect(() => {
    if (editOpen) {
      if (isToggled) {
        fetchCodecs();
      }
      fetchDevices(selectedType.productName);
    }

  }, [editOpen, isToggled])

  const fetchData = async (productName) => {
    try {
      setLoadingScreen(true);
      await Promise.all([
        fetchDevices(productName),
        fetchCodecs(),
      ]);
    } catch (error) {


    } finally {
      // Set loading to false once both are done (or error occurs)
      setLoadingScreen(false);
    }
  };
  
  const processJoinParameters = (dependencyMap, parameters) => {
    parameters.forEach(param => {
      const paramId = param.parameterId;

      if (dependencyMap[paramId]) {
        param.joinParameter = dependencyMap[paramId];

        // Remove reverse dependency
        param.joinParameter.forEach(joinParamId => {
          if (dependencyMap[joinParamId]) {
            const index = dependencyMap[joinParamId].indexOf(paramId);
            if (index > -1) {
              dependencyMap[joinParamId].splice(index, 1);
            }
            if (dependencyMap[joinParamId].length === 0) {
              delete dependencyMap[joinParamId]; // Clean up empty entries
            }
          }
        });

      } else {
        param.joinParameter = [];
      }
    });
  };
  const removeProductTypeById= async(idToDelete)=>{
    const accessToken = Cookies.get("ACCESS_TOKEN");
     setLoadingScreen(true);
      await axios.delete(`${environment.host}/core/product/productType/${idToDelete}`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((response) => {
        setProducts((prev) =>{
          const updatedProducts= prev.filter(product => product.id !== idToDelete);
        if(rowsPerPage*(page)>=updatedProducts.length){
          setPage(page-1);
        }
        return updatedProducts;
      }
      )
        setLoadingScreen(false);
      })
      .catch((error) => {
        setLoadingScreen(false);
      });
  }
  const mapDeviceData = (devices) => {
    const deviceDataMapped = devices.map(device => {
      if (updatedRemotelyConfigurable) {
        if ((device.remoteConfigAckTopic && device.remoteConfigTopic) && (device.remoteConfigAckTopic.length >= 0 && device.remoteConfigTopic.length >= 0)) {
          device.rmConfigured = "Configured";
        }
        else {
          device.rmConfigured = "Not-Configured";
        }
      }
      else {
        device.rmConfigured = "N/A"
      }
      if (updatedOtaUpgradable) {
        if ((device.otaAckTopic && device.otaRequestTopic) && (device.otaAckTopic.length >= 0 && device.otaRequestTopic.length >= 0)) {
          device.otaConfigured = "Configured";
        }
        else {
          device.otaConfigured = "Not-Configured";
        }
      }
      else {
        device.otaConfigured = "N/A"
      }
      return device;
    }
    )
    return deviceDataMapped;
  }

  const fetchDevices = async (productName) => {
    const result = await getDevicesWithProductType(productName);

    if (!result.isError) {
      const dataMapped = mapDeviceData(result.data);
      setDevicesProd(dataMapped);


    } else {

      console.error("Failed to fetch devices:", result.error);
    }
  };

  const fetchCodecs = async () => {
    const accessToken = AuthService.getAccessToken()
    await axios.get(`${environment.host}/core/codec?returnType=LIST`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((response) => {
        setCodecs(response.data.content);
      })
      .catch((error) => {
        console.error('Error fetching codecs:', error.response.statusText);
      });
  };
  const fetchMetaData = async () => {
    const accessToken = AuthService.getAccessToken();
    setLoadingScreen(true);
    const response = await axios.get(`${environment.host}/core/meta-data`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    })

    if (response.data.content) {
      setMetaData(response.data.content);
      setActuators(response.data.content.actuators.sort((a, b) => (a.name < b.name ? -1 : 1)));
      setLoadingScreen(false);
    }
  };

  const getAllSensores =async () =>{
    try{
      const response =await getAllSensors()
      if(response){
        const sortedSensors = response.sort((a, b) => (a.codeValue < b.codeValue ? -1 : 1));
        setSensors(sortedSensors);
      }
    }catch(error){
      console.log(error.message)
    }
  }

  useEffect(() => {
    if(isAddDeviceVisible && selectedType){
      const getUnAssignedDevices = async () => {
        setLoadingScreen(true);
        try{
          const response = await fetchUnassignedDevicesByProductType(selectedType.id);
          if (response) {
            const sortedDevices = response.sort((a, b) => (a.deviceName < b.deviceName ? -1 : 1));
            setDevicesNotInProductType(sortedDevices);
          }
        }
        catch(error){
          console.log(error.message)
        } finally{
          setLoadingScreen(false);
        }  
      };
      getUnAssignedDevices();
    }
  }, [isAddDeviceVisible, selectedType]);

  useEffect(() => {
    if (isAddDeviceVisible && selectedType) {
      const getOneProductType = async () => {
        setLoadingScreen(true);
        try{
          const response = await fetchProductType(selectedType.id);
          if (response) {
            const approvedVersions = (response.versions || []).filter(
              (version) => version.status === "APPROVED"
            );
    
            const versionOptions = approvedVersions.map((version) => ({
              label: version.versionNum,
              value: version.versionNum
            }));
    
            setVersions((prev) => ({
              ...prev,
              [expandedRow]: versionOptions
            }));
          }
        } catch(error){
          console.log(error.message)
        } finally{
          setLoadingScreen(false);
        }
      };
      getOneProductType();
    }
  }, [isAddDeviceVisible, selectedType]);

  useEffect(() => {
    if(expandedRow){
      
      const getProductTypeDevices = async () => {
        setLoadingScreen(true);
        try{
        const response = await fetchProductTypeDevices(selectedType.id);
        if (response) {
          const sortedDevices = response.sort((a, b) => (a.deviceName < b.deviceName ? -1 : 1));
          setDevicesProductExpanded(sortedDevices);
        }}
        catch(error){
          console.error("Failed to fetch devices:", error);
          setIsToasterOpen(true)
          setReqSuccess(false)
          setToasterMessage("Failed to fetch devices")
        }
        finally{
          setTimeout(() => {
            setIsToasterOpen(false);
            setLoadingScreen(false);
          }, 4000);
        }
      };
      getProductTypeDevices();
    }
  }, [expandedRow]);

  useEffect(()=>{
    const results = devicesProductExpanded.filter((obj) => {
      return  obj.name.toLowerCase().includes(searchDevice.trim().toLowerCase());
    });
   setFilterDevices(results)
  },[devicesProductExpanded,searchDevice])
  const handleConfigurationsClick = () => {
    history.push('/product-types');
  };

  const handleCancelToggle=()=>{
    setToggleOpen(false);
    setToggleType("");
    setconfigEnable(false);
  }
  const handleSaveConfigToggle=async()=>{
    const accessToken = AuthService.getAccessToken();
    const updatedData =
    {
      id: productTypeRMOTAEdit.id,
      ...(toggleType === "ota" ? { otaUpgradable: configEnable }
        : {}),
      ...(toggleType === "rm"
        ? { remotelyConfigurable: configEnable }
        : {}),
        ...(configEnable?{dataFormat:productTypeRMOTAEdit.dataFormat}:{})
    };


      const formData = new FormData();
      const jsonBlob = new Blob([JSON.stringify(updatedData)], { type: "application/json" });
      formData.append("productTypeDTO", jsonBlob);
      setLoadingScreen(true);
      try{
      const response = await axios.put(`${environment.host}/core/user/${AuthService.getUserId()}/product/productType/${productTypeRMOTAEdit.id}/Config`, formData, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })

      const updatedProductType = response.data;

      if (response.data.errorCode && response.data.errorCode.length > 0) {

        setReqSuccess(false);
         setIsToasterOpen(true);
         setToasterMessage(response.data.message);
         setLoadingScreen(false);
        setTimeout(() => {
          setIsToasterOpen(false);
          setToasterMessage("");
        }, 4000);
      } else {
        setReqSuccess(true);
         setIsToasterOpen(true);
         setToasterMessage("Configurations of Product Type Updated Successfully");
         setLoadingScreen(false);
        setLoadingScreen(false);
                setTimeout(() => {
          setIsToasterOpen(false);
          setToasterMessage("");
        }, 4000);

        // if (onUpdateSuccess) {
        //   onUpdateSuccess("Configurations of Product Type updated Successfully");
        // }

        getAllProducts();
        handleCancelToggle();
      }}
      catch (err) {
        console.log(err);
        setLoadingScreen(false);
        setReqSuccess(false);
        setIsToasterOpen(true);
        setToasterMessage("Something went wrong!");
        setLoadingScreen(false);
        setTimeout(() => {
          setIsToasterOpen(false);
          setToasterMessage("");
        }, 4000);
      }
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const toggleDeviceView = (isDeviceView) => {
    setProductTypeDeviceView(isDeviceView);
    setproductTypeConfigView(!isDeviceView);
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleReviewOpen = async (props) => {
    setLoadingScreen(true);
    try {
      const fullProduct = await fetchProductType(props.productType.id);
      setSelectedType(fullProduct);
      setReviewOpen(true);
    } catch (error) {
      console.error("Failed to fetch full product details:", error);
    } finally {
      setLoadingScreen(false);
    }
  };
  const handleReviewClose = () => {
    setReviewOpen(false);
  };

  const handleEditOpen = async (props) => {
    setLoadingScreen(true);
    try {
      const fullProduct = await fetchProductType(props.productType.id);
      const { productType } = { productType: fullProduct };

    await fetchData(productType.productName);
    setSelectedType(productType);
    setUpdatedOtaUpgradable(productType.otaUpgradable);
    setUpdatedRemotelyConfigurable(productType.remotelyConfigurable);
    setUpdatedCodecName(productType.codecName);
    setActuatorCodesOfDevice(productType.actuatorCodes);
    setIsToggled(productType.transcoder);
    setUpdatedConnectivity(productType.connectivity);
    setSensorCodesOfDevice(productType.sensorCodes);
    setUpdatedVersion(productType.versions);
    setUpdatedProductName(productType.productName);
    setUpdatedProtocol(productType.protocol);
    setUpdatedDataFormat(productType.dataFormat);
    setUpdatedPersistence(productType.persistence)
    const baseVersion = productType.versions[0]
    if (baseVersion) {
      processJoinParameters(baseVersion.joinParameters, baseVersion.remoteConfigurations);
      setParameters(baseVersion.remoteConfigurations);
      setInitialParameters(baseVersion.remoteConfigurations);
      setVersionNumEdit(baseVersion);
      if(baseVersion.versionNum&&baseVersion.versionNum!="0.0.0"){
      setBaseVersionNum(baseVersion.versionNum)
      }
    }
    
    if (productType.codecName !== null) {
      setStep("select");
      setCodecToSend(productType.codecName);
    }
    
    setEditOpen(true);
    } catch (error) {
      console.error("Failed to fetch full product details:", error);
    } finally {
      setLoadingScreen(false);
    }
  };

  const handleEditClose = () => {
    setEditOpen(false);
    
  };

  const handleDeleteOpen = (props,type) => {
    setDeleteOpen(true);
    if(type == 'product'){
      setSelectedType(props.productType);
      setType(type);
    }else if(type == 'device'){
      setSelectedDevice(props.productType);
      setType(type);

    }
  };
  const handleDeleteClose = () => {
    setDeleteOpen(false);
  };

  const handleExpand = (index, product) =>{
    setExpandedRow(prev => {
      if(prev == ((page-1)*10 + index)){
        return null
      }else{
        setSelectedType(product);
        setSearchDevice('');
        return ((page-1)*10 + index)
      }
    })
  }

  const handleAddDevice = () => {
    setIsAddDeviceVisible(true)
  }

  const closeAddDevice = () =>{
    setSelectedDevices([])
    setIsAddDeviceVisible(false)
    setSelectedProductTypeVersion("")
  }

  const addDevicesToProductType = async () => {
    if (selectedDevices.length === 0) {
      setIsToasterOpen(true);
      setReqSuccess(false);
      setToasterMessage("Please select at least one device to add.");
      setTimeout(() => {
        setIsToasterOpen(false);
        setLoadingScreen(false);
      }, 4000);
      return;
    }
    setLoadingScreen(true);
    try {
      const response = await addProductTypeToDevices(selectedType.id, selectedDevices, selectedProductTypeVersion);
      if (response) {
        setIsToasterOpen(true);
        setReqSuccess(true);
        setToasterMessage("Devices added successfully");
        setIsAddDeviceVisible(false);
        setSelectedDevices([]);
        setSelectedProductTypeVersion("");
        const updatedDevices = devicesNotInProductType.filter(device => !selectedDevices.includes(device.id));
        setDevicesNotInProductType(updatedDevices);
        const updatedFilterDevices = filterDevices.concat(devicesNotInProductType.filter(device => selectedDevices.includes(device.id)));
        setFilterDevices(updatedFilterDevices);
        setExpandedRow(null);
      } else {
        setIsToasterOpen(true);
        setReqSuccess(false);
        setToasterMessage("Error adding devices");
      }
    } catch (error) {
      console.error("Error adding devices to product type:", error);
      setIsToasterOpen(true);
      setReqSuccess(false);
      setToasterMessage("Error adding devices");
    } finally {
      setTimeout(() => {
        setIsToasterOpen(false);
        setLoadingScreen(false);
      }, 4000);
    }
  };

  const removeDeviceFromProductType = async (deviceId) => {
    setLoadingScreen(true);
    try {
      const response = await removeProductTypeFromDevices(selectedType.id, deviceId);
      if (response) {
      }
    } catch (error) {
      setIsToasterOpen(true);
      setReqSuccess(false);
      setToasterMessage("Error removing device from product Type");
      console.error("Error removing device from product type:", error);
    } finally {
      setLoadingScreen(false);
      const updatedFilterDevices = filterDevices.filter(device => device.id !== deviceId);
      setFilterDevices(updatedFilterDevices);
      setIsToasterOpen(true);
      setReqSuccess(true);
      setToasterMessage("Device successfully removed from product Type");

      setTimeout(() => {
        setIsToasterOpen(false);
        setLoadingScreen(false);
      }, 4000);
    }
  };

  const getAllProducts = () => {
    setLoadingScreen(true);
    axios.get(`${environment.host}/core/products?returnType=LIST`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${AuthService.getAccessToken()}`,
      },
    })
      .then((response) => {
        const productsData = response.data.content || [];
        setProducts(productsData);
        const versionNumbers = productsData.map(item =>
          Array.isArray(item.versions)
            ? item.versions.map(version => version.versionNum)
            : []
        );
        setProdctTypeVersions(versionNumbers)
        // Flatten the products data to get unique product types
        const allProductTypes = productsData.reduce((acc, curr) => {
          acc[curr.productType] = true;
          return acc;
        }, {});
        setAllProducts(Object.keys(allProductTypes));
        setLoadingScreen(false);
      })
      .catch((error) => {
        console.error("Error fetching products:", error);
        setProducts([]);
        setAllProducts([]);
        setLoadingScreen(false);
      });
  };



  useEffect(() => {
    const results = products.filter((obj) => {
      return  obj.productName.toLowerCase().includes(search.trim().toLowerCase());
    });
    setFilteredProducts(results);
  }, [search,products]);

  const handleSelectProductTypeVersion = (event) =>{
    setSelectedProductTypeVersion(event.value)
  }

  
    const handleOpenRMOTAConfiguration = async (product) => {
      setLoadingScreen(true);
      try {
        const fullProduct = await fetchProductType(product.id);
        console.log(fullProduct.versions);
        setProductTypeRMOTAEdit({
          id:fullProduct.id,
          productName:fullProduct.productName,
          remotelyConfigurable:fullProduct.remotelyConfigurable,
          otaUpgradable:fullProduct.otaUpgradable,
          dataFormat:fullProduct.dataFormat,
          versions:fullProduct.versions,
          remoteConfigAckTopic:fullProduct.remoteConfigAckTopic,
          remoteConfigTopic:fullProduct.remoteConfigTopic,
          otaAckTopic:fullProduct.otaAckTopic,
          otaRequestTopic:fullProduct.otaRequestTopic
        });
        setIsVersionManagment(true);
        setUpdatedDataFormat(fullProduct.dataFormat);
        
        setUpdatedVersion(fullProduct.versions);
        const lastVersion = getLatestVersion(fullProduct.versions);
        const baseVersion = fullProduct.versions[0];
        if (lastVersion) {
          processJoinParameters(lastVersion.joinParameters, lastVersion.remoteConfigurations);
          setParameters(lastVersion.remoteConfigurations);
          setInitialParameters(lastVersion.remoteConfigurations);
          setVersionNumEdit(lastVersion);
          setLastVersion(lastVersion);
        }
        if (baseVersion && baseVersion.versionNum && baseVersion.versionNum != "0.0.0") {
          setBaseVersionNum(baseVersion.versionNum)
        }
        setUpdatedRemotelyConfigurable(fullProduct.remotelyConfigurable);
        setUpdatedOtaUpgradable(fullProduct.otaUpgradable);
        setEditRMOTAOpen(true);
      } catch (error) {
        console.error("Failed to fetch full product details:", error);
      } finally {
        setLoadingScreen(false);
      }
    };



  const handleChangeOTAToggle = async (product, newStatus) => {
    if (!updatedOtaUpgradable && !hasPackagePermission("OTAManager")) {
      setUpgradePopup({
        open: true,
        featureName: 'OTA'
      });
    } else {
      setLoadingScreen(true);
      try {
        const fullProduct = await fetchProductType(product.id);
        setProductTypeRMOTAEdit({
          id: fullProduct.id,
          productName: fullProduct.productName,
          remotelyConfigurable: fullProduct.remotelyConfigurable,
          otaUpgradable: fullProduct.otaUpgradable,
          dataFormat: fullProduct.dataFormat,
          versions: fullProduct.versions,
          remoteConfigAckTopic: fullProduct.remoteConfigAckTopic,
          remoteConfigTopic: fullProduct.remoteConfigTopic,
          otaAckTopic: fullProduct.otaAckTopic,
          otaRequestTopic: fullProduct.otaRequestTopic
        });
        setIsVersionManagment(false);
        if (newStatus) {
          setUpdatedDataFormat(fullProduct.dataFormat);

          const hasAnyBinFiles = (fullProduct.versions != null && fullProduct.versions.length != 0) && fullProduct.versions.some(
            v => (v.binURL != null)
          );
          console.log(hasAnyBinFiles, fullProduct.versions)
          if (!hasAnyBinFiles) {
            setUpdatedVersion(fullProduct.versions);
            const baseVersion = fullProduct.versions[0]
            if (baseVersion) {
              processJoinParameters(baseVersion.joinParameters, baseVersion.remoteConfigurations);
              setParameters(baseVersion.remoteConfigurations);
              setInitialParameters(baseVersion.remoteConfigurations);
              setVersionNumEdit(baseVersion);
              if (baseVersion.versionNum && baseVersion.versionNum != "0.0.0") {
                setBaseVersionNum(baseVersion.versionNum)
              }
            }
            setUpdatedRemotelyConfigurable(fullProduct.remotelyConfigurable);
            setUpdatedOtaUpgradable(newStatus);
            setEditRMOTAOpen(true);
          }
          else {
            setconfigEnable(newStatus);
            setToggleOpen(true);
            setToggleType("ota");
          }
        }
        else {
          setconfigEnable(newStatus);
          setToggleOpen(true);
          setToggleType("ota");
        }
      } catch (error) {
        console.error("Failed to fetch full product details:", error);
      } finally {
        setLoadingScreen(false);
      }
    }
  }

  const handleChangeRemoteToggle = async (product, newStatus) => {
    if (newStatus && !hasPackagePermission("RemoteManager")) {
      setUpgradePopup({
        open: true,
        featureName: 'Remote Manager'
      });
    } else {
      setLoadingScreen(true);
      try {
        const fullProduct = await fetchProductType(product.id);
        setProductTypeRMOTAEdit({
          id: fullProduct.id,
          productName: fullProduct.productName,
          remotelyConfigurable: fullProduct.remotelyConfigurable,
          otaUpgradable: fullProduct.otaUpgradable,
          dataFormat: fullProduct.dataFormat,
          versions: fullProduct.versions,
          remoteConfigAckTopic: fullProduct.remoteConfigAckTopic,
          remoteConfigTopic: fullProduct.remoteConfigTopic,
          otaAckTopic: fullProduct.otaAckTopic,
          otaRequestTopic: fullProduct.otaRequestTopic
        });
        setIsVersionManagment(false);
        if (newStatus) {
          setUpdatedDataFormat(fullProduct.dataFormat);
          const hasAnyParameters = fullProduct.versions.some(
            v => Array.isArray(v.remoteConfigurations) && v.remoteConfigurations.length > 0
          );
          console.log(hasAnyParameters, fullProduct.versions)
          if (!hasAnyParameters) {
            setUpdatedVersion(fullProduct.versions);
            const latestVersion = getLatestVersion(fullProduct.versions);
            if (latestVersion) {
              processJoinParameters(latestVersion.joinParameters, latestVersion.remoteConfigurations);
              setParameters(latestVersion.remoteConfigurations);
              setInitialParameters(latestVersion.remoteConfigurations);
              setVersionNumEdit(latestVersion);
            }
            setUpdatedRemotelyConfigurable(newStatus);
            setUpdatedOtaUpgradable(fullProduct.otaUpgradable);
            setEditRMOTAOpen(true);
          }
          else {
            setconfigEnable(newStatus);
            setToggleOpen(true);
            setToggleType("rm");
          }
        } else {
          setconfigEnable(newStatus);
          setToggleOpen(true);
          setToggleType("rm");
        }
      } catch (error) {
        console.error("Failed to fetch full product details:", error);
      } finally {
        setLoadingScreen(false);
      }
    }
  };
  const handleEditRMOTAClose = () => {
    setUpdatedVersion([]);
    setVersionNumEdit(undefined);
    setEditRMOTAOpen(false);
    setUpdatedOtaUpgradable(false);
    setUpdatedRemotelyConfigurable(false);
    setLastVersion(null);
    setUpdatedVersion([]);
    setParameters([]);
    setIsVersionManagment(false);

  }
  const AddDevicesPopup = () => {
    const productTypeVersionOptions = versions && versions[Object.keys(versions)[0]] ? versions[Object.keys(versions)[0]] : [];
    const uniqueProductTypeVersionOptions = productTypeVersionOptions.filter((value, index, self) => 
        index === self.findIndex((t) => (
            t.value === value.value
        ))
    );
    return (
      <Grid item xs={12} md={12}>
        <MultiSelectDropDown
          options={devicesNotInProductType}
          isDropdownVisible={isAddDeviceVisible}
          setIsDropdownVisible={setIsAddDeviceVisible}
          setSelectedDevices={setSelectedDevices}
          selectedDevices={selectedDevices}
          handleSave={addDevicesToProductType}
          handleCancel={closeAddDevice}
          productTypeVersions={uniqueProductTypeVersionOptions}
          selectedProductTypeVersion = {selectedProductTypeVersion}
          handleSelectProductTypeVersion = {handleSelectProductTypeVersion}
          setSelectedProductTypeVersion = {setSelectedProductTypeVersion}
          type='productType'
        />
      </Grid>
    )
  }

       const UpgradePopup = ({ 
        open, 
        onClose, 
        onUpgrade,
        featureName,
        onCloseWithFeature
      }) => {
        return (
          <Dialog
            open={open}
            onClose={onClose}
            PaperProps={{
              style: {
                width: '512px',
                maxWidth: '512px',
              },
            }}
          >
            <DialogTitle>
              <Grid container justifyContent="flex-end" alignItems="center">
                <IconButton onClick={onClose} size="small">
                  <Close />
                </IconButton>
              </Grid>
            </DialogTitle>
            <DialogContent>
              <Typography variant="body1" style={{ marginBottom: '15px' }}>
                You've just configured a feature available only in the Basic package. To perform {featureName} operations, please upgrade your plan.
              </Typography>
              <Grid container justifyContent="flex-end" spacing={1}>
                <Grid item>
                  <Button
                    variant="contained"
                    onClick={onUpgrade}
                    className={style.buttonContained}
                    style={{ backgroundColor: '#2A7CED', color: '#FFFFFF' }}
                  >
                    Upgrade Now
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    variant="outlined"
                    onClick={onCloseWithFeature}
                    className={style.buttonOutlined}                
                  >
                    OK
                  </Button>
                </Grid>
              </Grid>
            </DialogContent>
          </Dialog>
        );
      };

  const OnSearchDevice = (event) =>{
    const value = event.target.value.trim().toLowerCase()
    setSearchDevice(value);
  }
  

  return (
    <ThemeProvider theme={theme}>
      <div className={`testing`}>
        <div className="page-heading">
          Product Types
        </div>
        {productTypeConfigView?
      <Grid container className={style.container}>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item xs={6} md={3} className={classes.searchBarProductType}>
            <SearchBar placeholder="Search Product Name" value={search} onChange={(e) => {setSearch(e.target.value);setPage(0)}}/>
          </Grid>
          <Grid item md={9}></Grid>
            {/* <Grid
              item
                xs={6}
                md={2}
                style={{textAlign: "right",}}
              >
              <Button
                variant="contained"
                onClick={handleConfigurationsClick}
                className={classes.configuration}
                style={{textTransform: "none", whiteSpace:"nowrap" }}
              >
                Version Management
              </Button>
          </Grid> */}
        </Grid>
        <Grid
          item
          xs={12}
          md={12}
          style={{marginTop: "20px"}}
        >
  
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell
                  style={{
                    borderBottomColor: "white",
                    borderTopColor: "white",
                    backgroundColor: "white",
                  }}
                >
                    <Typography className={style.tablehead}                     
                              display="inline"
                              >
                    Product Name
                    </Typography>
                </TableCell>
                <TableCell
                  style={{
                    textAlign: "left",
                    borderBottomColor: "white",
                    borderTopColor: "white",
                    backgroundColor: "white",
                  }}
                >
                    <Typography className={style.tablehead}                     
                                        display="inline"
                                      >
                    Protocol
                  </Typography>
                </TableCell>
                <TableCell
                  style={{
                    textAlign: "left",
                    borderBottomColor: "white",
                    borderTopColor: "white",
                    backgroundColor: "white",
                  }}
                >
                    <Typography className={style.tablehead}                     
                                        display="inline"
                                      >
                    Transcoding Enabled
                  </Typography>
                </TableCell>
                <TableCell
                  style={{
                    textAlign: "left",
                    borderBottomColor: "white",
                    borderTopColor: "white",
                    backgroundColor: "white",
                  }}
                >
                    <Typography className={style.tablehead}                     
                                        display="inline"
                                      >
                    Remote Config
                  </Typography>
                </TableCell>
                <TableCell
                  style={{
                    textAlign: "left",
                    borderBottomColor: "white",
                    borderTopColor: "white",
                    backgroundColor: "white",
                  }}
                >
                    <Typography className={style.tablehead}                     
                                        display="inline"
                                      >
                    OTA Upgradable
                  </Typography>
                </TableCell>
                <TableCell
                  style={{
                    textAlign: "left",
                    borderBottomColor: "white",
                    borderTopColor: "white",
                    backgroundColor: "white",
                  }}
                >
                    <Typography className={style.tablehead}                     
                                        display="inline"
                                      >
                    Actions
                  </Typography>
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {filteredProducts !== undefined &&
                filteredProducts  //filtered by search name
                  .slice(
                    page * rowsPerPage,
                    page * rowsPerPage + rowsPerPage
                  )
                  .map((product, i) => (
                    <React.Fragment key={i}>
                      <TableRow key={i}>
                        <TableCell
                          style={{
                            textAlign: "left",
                            borderBottomColor: "white",
                            borderTopColor: "white",
                            backgroundColor:
                              i % 2 === 0 || i / 2 === 0
                                ? "#F9F9F9"
                                : "white",
                          }}
                        >
                          <Typography
                            display="inline"
                            className={classes.tableText}
                          >
                            {product.productName}
                          </Typography>
                        </TableCell>
                        <TableCell
                          style={{
                            textAlign: "left",
                            borderBottomColor: "white",
                            borderTopColor: "white",
                            backgroundColor:
                              i % 2 === 0 || i / 2 === 0
                                ? "#F9F9F9"
                                : "white",
                          }}
                        >
                          <Typography className={classes.tableText}>
                            {product.protocol}
                          </Typography>
                        </TableCell>
                        <TableCell
                          style={{
                            textAlign: "left",
                            borderBottomColor: "white",
                            borderTopColor: "white",
                            backgroundColor:
                              i % 2 === 0 || i / 2 === 0
                                ? "#F9F9F9"
                                : "white",
                          }}
                        >
                          <Grid item 
                            className={classes.tableText}
                            style={{
                              paddingLeft: "5px",
                              display:"inline"
                            }}>
                            {product.transcoder ?(
                                  <Chip
                                    className={style.greenChip}
                                    label="True"
                                  />):
                                  (<Chip
                                    className={style.redChip}
                                    label="False"
                                  />)
                                }
                            </Grid>
                        </TableCell>
                        <TableCell
                          style={{
                            textAlign: "left",
                            borderBottomColor: "white",
                            borderTopColor: "white",
                            backgroundColor:
                              i % 2 === 0 || i / 2 === 0
                                ? "#F9F9F9"
                                : "white",
                          }}
                        >
                          <Grid item
                            className={classes.tableText}
                            style={{
                              paddingLeft: "5px",
                              display: "inline"
                            }}>
                            <Tooltip title={product.remotelyConfigurable ? "DISABLE" : "ENABLE"} placement="top">
                              <FormControlLabel
                                style={{
                                  marginLeft: 0,
                                  marginRight: 0,
                                }}
                                control={
                                  <BlueSwitch
                                    checked={product.remotelyConfigurable}
                                    onChange={(event) => {
                                      const newStatus = product.remotelyConfigurable ? false : true;
                                      handleChangeRemoteToggle(product, newStatus);
                                    }}
                                    size="small"
                                  />
                                }
                                label=""
                              />
                            </Tooltip>

                          </Grid>
                        </TableCell>
                        <TableCell
                          style={{
                            textAlign: "left",
                            borderBottomColor: "white",
                            borderTopColor: "white",
                            backgroundColor:
                              i % 2 === 0 || i / 2 === 0
                                ? "#F9F9F9"
                                : "white",
                          }}
                        >
                          <Grid item
                            className={classes.tableText}
                            style={{
                              paddingLeft: "5px",
                              display: "inline"
                            }}>

                            <Tooltip title={product.otaUpgradable ? "DISABLE" : "ENABLE"} placement="top">
                              <FormControlLabel
                                style={{
                                  marginLeft: 0,
                                  marginRight: 0,
                                }}
                                control={
                                  <BlueSwitch
                                    checked={product.otaUpgradable}
                                    onChange={(event) => {
                                      const newStatus = product.otaUpgradable ? false : true;
                                      handleChangeOTAToggle(product, newStatus);
                                    }}
                                    size="small"
                                  />
                                }
                                label=""
                              />
                            </Tooltip>
                          </Grid>
                        </TableCell>
                        <TableCell
                          style={{
                            textAlign: "left",
                            borderBottomColor: "white",
                            borderTopColor: "white",
                            backgroundColor:
                              i % 2 === 0 || i / 2 === 0
                                ? "#F9F9F9"
                                : "white",
                          }}
                        >
                          <Grid item style={{ display: 'flex' }}>
                            <Grid container spacing={1} alignItems="center">
                              <Tooltip title={"Version Management"} placement="top">
                              <IconButton size="small" className={style.iconStyle} 
                              style={{
                                cursor:
                                  product.otaUpgradable || product.remotelyConfigurable
                                    ? "pointer"
                                    : "not-allowed",
                              }}
                                onClick={() => { if (product.otaUpgradable || product.remotelyConfigurable) { handleOpenRMOTAConfiguration(product) } }}>
                                <RMOTAConfigurationIcon disabled={ !product.otaUpgradable && !product.remotelyConfigurable}/>
                               </IconButton>
                               </Tooltip>
                                <Tooltip title={"View"} placement="top">
                              <IconButton
                                className={style.iconStyle}
                                onClick={() =>
                                  handleReviewOpen({
                                    productType: product
                                  })
                                }
                              >
                                <ViewIconNew color = '#324054'/>
                              </IconButton>
                              </Tooltip>
                               <Tooltip title={"Edit"} placement="top">
                              <IconButton
                                className={style.iconStyle}
                                onClick={() => {
                                  handleEditOpen({
                                    productType: product
                                  });
                                }}
                              >
                                <EditIconLargeDark/>
                              </IconButton>
                              </Tooltip>
                              <Tooltip title={"Delete"} placement="top">
                              <IconButton
                                className={style.iconStyle}
                                onClick={() => {
                                  handleDeleteOpen({
                                    productType: product
                                  },'product');
                                }}
                              >
                                <DeleteIconLarge />
                              </IconButton>
                              </Tooltip>
                            </Grid>
                            <Grid container justifyContent="flex-end"  style={{ width: "fit-content" }}>
                              <IconButton size='small' onClick={() => handleExpand(i , product)}>
                                  {expandedRow == ((page-1)*10 + i) ? <ExpandCollapseIcon /> : <ExpandIcon />}
                              </IconButton>
                            </Grid>
                          </Grid>
                        </TableCell>
                      </TableRow>
                      
                      {expandedRow == ((page-1)*10 + i) &&
                        <React.Fragment key={`${i}-expanded`}>
                          <TableRow style={{ width: '100%', backgroundColor: 'white' }}>
                            <TableCell colSpan={6}>
                              <Grid container >
                                <Grid item xs={12} md={12} style={{ display: 'flex', justifyContent: 'space-between' }}>
                                  <Grid item xs={4} md={4}>
                                    <SearchBar onChange={OnSearchDevice}/>
                                  </Grid>
                                  <Grid item xs={3} md={3} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <Button style={{ backgroundColor: primaryBlue, color: white }} variant='contained' onClick={handleAddDevice}>Add Devices</Button>
                                  </Grid>

                                </Grid>


                                <Grid item xs={12} md={12} style={{ marginTop: '10px', border: '1px solid rgb(224, 224, 224)' }}>
                                  <TableContainer style={{ maxHeight: '250px', overflowY: 'auto' }}>
                                    <Table>
                                      <TableHead>
                                        <TableRow>
                                          <TableCell className={style.tablehead} style={{ width: '85%' }}>Available Devices</TableCell>

                                          <TableCell className={style.tablehead}>Action</TableCell>

                                        </TableRow>
                                      </TableHead>
                                      <TableBody >
                                        {filterDevices && filterDevices.length > 0 ? (
                                          filterDevices.map((device, index) => (
                                            <TableRow key={index} style={{ backgroundColor: index % 2 == 1 ? '#FFFFFF' : '#F5F5F5' }}>
                                              <TableCell style={{ width: '85%' }}>{device.name}</TableCell>
                                              <TableCell>
                                                <IconButton size="small" onClick={() => handleDeleteOpen({ productType: device }, 'device')}>
                                                  <TrashIcon />
                                                </IconButton>
                                              </TableCell>

                                            </TableRow>
                                          ))
                                        ) : (
                                          <TableRow style={{ backgroundColor: '#F5F5F5' }}>
                                            <TableCell colSpan={2}>
                                              <Grid container justifyContent="center">
                                                <Grid item>No devices found</Grid>
                                              </Grid>
                                            </TableCell>
                                          </TableRow>
                                        )}
                                      </TableBody>
                                    </Table>
                                  </TableContainer>
                                </Grid>
                              </Grid>
                            </TableCell>
                          </TableRow>
                        </React.Fragment>
                      }
                    </React.Fragment>
                  ))}
                  
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
        <Grid container justifyContent="center">
            <Pagination className={style.pagination}
                      count={Math.ceil(filteredProducts.length / rowsPerPage)} // Calculate total pages
                      page={page + 1} // Convert 0-based index to 1-based for Pagination
                      onChange={(event, value) => setPage(value - 1)} // Update page state
            />
        </Grid>      
      {reviewOpen && (
        <ViewProductType
          productType={selectedType}
          open={reviewOpen}
          onClose={handleReviewClose}
          metaData={metaData}
        />
      )}
            <UpgradePopup
              open={upgradePopup.open}
              onClose={() => setUpgradePopup({...upgradePopup, open: false})}
              onUpgrade={() => {
                setUpgradePopup({...upgradePopup, open: false});
                window.open(environment.azurepageLink);
              }}
              featureName={upgradePopup.featureName}
              onCloseWithFeature={() => {
                setUpgradePopup({...upgradePopup, open: false});
                if (upgradePopup.featureName === 'Remote Manager') {
                  setUpdatedRemotelyConfigurable(!updatedRemotelyConfigurable);
                } else if (upgradePopup.featureName === 'OTA') {
                  setUpdatedOtaUpgradable(!updatedOtaUpgradable)
                }
              }}
            />
      {editOpen  && (
        <EditProductType
          productType={selectedType}
          open={editOpen}
          onClose={() => handleEditClose()}
            onUpdateSuccess={(msg) => {
              setToasterMessage(msg || "Product Type Updated Successfully");
              setReqSuccess(true);
              setIsToasterOpen(true);
              setTimeout(() => {
                setIsToasterOpen(false);
              }, 3000); 
          }}
          toggleDeviceView={toggleDeviceView}
          updatedOtaUpgradable={updatedOtaUpgradable}
          setUpdatedOtaUpgradable={setUpdatedOtaUpgradable}
          updatedRemotelyConfigurable={updatedRemotelyConfigurable}
          setUpdatedRemotelyConfigurable={setUpdatedRemotelyConfigurable}
          setUpdatedCodecName={setUpdatedCodecName}
          setActuatorCodesOfDevice={setActuatorCodesOfDevice}
          setIsToggled={setIsToggled}
          setUpdatedConnectivity={setUpdatedConnectivity}
          setSensorCodesOfDevice={setSensorCodesOfDevice}
          
          setUpdatedProductName={setUpdatedProductName}
          setUpdatedProtocol={setUpdatedProtocol}
          setUpdatedPersistence={setUpdatedPersistence}
          setUpdatedDataFormat={setUpdatedDataFormat}
          setActuatorsOfDevice={setActuatorsOfDevice}
          setSensorsOfDevice={setSensorsOfDevice}
          updatedDataFormat={updatedDataFormat}
          updatedPersistence={updatedPersistence}
          updatedConnectivity={updatedConnectivity}
          updatedProtocol={updatedProtocol}
          updatedCodecName={updatedCodecName}
          updatedProductName={updatedProductName}
          updatedVersion={updatedVersion}
          sensorCodesOfDevice={sensorCodesOfDevice}
          actuatorCodesOfDevice={actuatorCodesOfDevice}
          sensorsOfDevice={sensorsOfDevice}
          actuatorsOfDevice={actuatorsOfDevice}
          isToggled={isToggled}
          id={selectedType.id}
          fetchDevices={fetchDevices} 
          devices={devicesProd} 
          setDevices={setDevicesProd}
          mapDeviceData={mapDeviceData}
          codecToSend={codecToSend}
          setCodecToSend={setCodecToSend}
          selectedCodec={selectedCodec}
          setSelectedCodec={setSelectedCodec}
          sensors={sensors}
          setSensors={setSensors}
          actuators={actuators}
          setActuators={setActuators}
          step={step}
          setStep={setStep}
          codecs={codecs}
          setCodecs={setCodecs}
          metaData={metaData}
          setMetaData={setMetaData}
          getAllProducts={getAllProducts}
          parameters={parameters}
          setParameters={setParameters}
          setUpdatedVersion={setUpdatedVersion}
          baseVersionNum={baseVersionNum}
          versionEdit={versionNumEdit}
          setVersionEdit={setVersionNumEdit}
          processJoinParameters={processJoinParameters}/>
      )}
      <EditRMOTA
              productTypeRMOTAEdit={productTypeRMOTAEdit}
              baseVersionNum={baseVersionNum}
              versionEdit={versionNumEdit}
              setVersionEdit={setVersionNumEdit}
              processJoinParameters={processJoinParameters}
              parameters={parameters}
              setParameters={setParameters}
              updatedVersion={updatedVersion}
              setUpdatedVersion={setUpdatedVersion}
              openEdit={editRMOTAOpen}
              isVersionManagement={isVersionManagement}
              updatedDataFormat={updatedDataFormat}
              setUpdatedDataFormat={setUpdatedDataFormat}
              onClose={() => handleEditRMOTAClose()}
              updatedRemotelyConfigurable={updatedRemotelyConfigurable}
              updatedOtaUpgradable={updatedOtaUpgradable}
              setUpdatedOtaUpgradable={setUpdatedOtaUpgradable}
              setUpdatedRemotelyConfigurable={setUpdatedRemotelyConfigurable}
              onUpdateSuccess={(msg) => {
                setToasterMessage(msg || "Configurations of Product Type Updated Successfully");
                setReqSuccess(true);
                setIsToasterOpen(true);
                setTimeout(() => {
                  setIsToasterOpen(false);
                }, 3000); 
          }}
          getAllProducts={getAllProducts}
          intialParameters={intialParameters}
          lastVersion={lastVersion}
          setLastVersion={setLastVersion}

              
      />
      {deleteOpen && (
        <DeleteProductType
          productType={selectedType}
          device={selectedDevice}
          open={deleteOpen}
          onClose={handleDeleteClose}
          removeProductTypeById={removeProductTypeById}
          removeDeviceFromProductType={removeDeviceFromProductType}
          type={type}
        />
      )}
      {toggleOpen && (
        <ToggleConfig
          productType={productTypeRMOTAEdit}
          enable={configEnable}
          open={toggleOpen}
          onClose={handleCancelToggle}
          type={toggleType}
          onSaveClick={handleSaveConfigToggle}

        />
      )}
      
    </Grid>:""}
    {productTypeDeviceView?<DevicesProductType 
    productType={selectedType}  
    otaToggled={updatedOtaUpgradable} 
    rmToggled={updatedRemotelyConfigurable} 
    
    toggleDeviceView={toggleDeviceView} 
    fetchDevices={fetchDevices} 
    devices={devicesProd} 
    setDevices={setDevicesProd}
    mapDeviceData={mapDeviceData}
    />
    :""}
    <DialogPopup
      open={isAddDeviceVisible}
      onClose={closeAddDevice}
      title='add devices'
      buttonRequired={false}
      dialogContent={<AddDevicesPopup />}
    />
    {<LoadingScreen loading={loadingScreen}/>}
    <ToasterComponent
            reqSuccess={reqSuccess}
            message={toasterMessage}
            toaster={isToasterOpen}
          />
  </div>
  
  </ThemeProvider>
  );
}

const useLocalStyles = makeStyles((theme: Theme) => ({
  container: {
    paddingTop: "20px",
  },
  filter: {
    backgroundColor: white,
    color: secondaryTextColor,
    boxShadow: "none",
  },
  tableText: {
    fontSize: "14px",
    color: "#3C3C3C",
    paddingTop: "10px",
    paddingBottom: "10px",
  },
  configuration: {
    backgroundColor: primaryBlue,
    color: white,
    boxShadow: "none",
    "&:hover": {
      backgroundColor: primaryBlue,
      color: white,
      boxShadow: "none",
    },
    [theme.breakpoints.down("md")]: {
      margin: "10px",

    },
  },
  searchBarProductType:{
    display:"flex",
    justifyContent:"left",
    maxWidth:"220px"
  }

}));

const BlueSwitch = withStyles({
  switchBase: {
    color: "#D9D9D9",
    '&$checked': {
      color: "#2A7BEC",
    },
    '&$checked + $track': {
      backgroundColor: "#2A7BEC",
    },
  },
  checked: {},
  track: {},
})(Switch);